module.exports = __webpack_public_path__ + "static/media/star-fr.c2da2ea5.png";